export enum QueryStatus {
    NOT_READY = 'NOT_READY',
    READY = 'READY',
    NOT_RUNNING = 'WAITING',
    RUNNING = 'RUNNING',
    FINISHED = 'FINISHED',
    ERROR = 'ERROR',
    CANCELLED = 'CANCELLED',
}

export interface Query {
    transformer?: string
    columns: QueryField[]
    rows: QueryField[]
    values: QueryField[]
    filters: QueryField[]
    filterLabels: FilterLabel[]
}

export interface FilterLabel {
    field: string
    title: string
    values: string[]
}

export interface QueryField {
    code: string
    type: string
    aggtype?: string
    value?: string
    alias?: string
    distinct: boolean
}

export interface Cell {
    id: number
    value: number | string | undefined | null
    order?: number
}

export interface QueryResult {
    colHeaders: string | undefined,
    rowHeaders: string | undefined,
    rawHeaders: Cell[][],
    rawContent: Cell[][],
    message: string | undefined,
    valueAvailable: boolean,
    restrictions: []
    defMap: string | undefined
}